export default __webpack_public_path__ + "logo-tuv-1946206c1f990324bf9e4b11fb13ccd7.svg";